import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
const AppVersionComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: ", ";\n  font-size: 13px;\n  font-weight: 350;\n  color: #979797;\n  z-index: 9999;\n  ", "\n"])), props => props.isPortal ? "fixed" : "relative", props => {
  if (props.position === "topLeft" /* topLeft */) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        top: 0;\n        left: 0;\n        padding-left: 10px;\n        padding-top: 10px;\n      "])));
  } else if (props.position === "topCenter" /* topCenter */) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        display: flex;\n        justify-content: center;\n        top: 0;\n      "])));
  } else if (props.position === "topRight" /* topRight */) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        top: 0;\n        right: 0;\n        padding-right: 10px;\n        padding-top: 10px;\n      "])));
  } else if (props.position === "bottomLeft" /* bottomLeft */) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        bottom: 0;\n        left: 0;\n        padding-left: 10px;\n        padding-bottom: 10px;\n      "])));
  } else if (props.position === "bottomCenter" /* bottomCenter */) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        display: flex;\n        justify-content: center;\n        bottom: 0;\n        width: 100%;\n        padding-bottom: 10px;\n      "])));
  } else if (props.position === "bottomRight" /* bottomRight */) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        bottom: 0;\n        right: 0;\n        padding-right: 10px;\n        padding-bottom: 10px;\n      "])));
  }
});
const AppVersion = props => {
  const {
    version,
    isPortal = false,
    portalId,
    style = {},
    position = "center" /* center */
  } = props;
  const portalRoot = isPortal && portalId && document.getElementById(portalId) ? document.getElementById(portalId) : document.body;
  const appVersionComponent = /* @__PURE__ */jsxs(AppVersionComponent, {
    position,
    isPortal,
    style,
    children: ["App-version: ", version]
  });
  return /* @__PURE__ */jsx(Fragment, {
    children: isPortal ? createPortal(appVersionComponent, portalRoot) : appVersionComponent
  });
};
export { AppVersion as default };